import { University, Vehicle, Trip } from '../types';

export const SEED_UNIVERSITIES: University[] = [
  // === محافظة مطروح / الساحل الشمالي والعلمين (قريبة جداً من الإسكندرية) ===
  {
    id: 'uni_alamein_intl',
    name: 'جامعة العلمين الدولية (AIU)',
    governorate: 'مطروح',
    city: 'مدينة العلمين الجديدة',
    address: 'الطريق الساحلي الدولي - مدينة العلمين الجديدة',
    campus: 'مدينة العلمين الجديدة',
    active: true,
    isActive: true,
    createdAt: '2026-10-01T00:00:00.000Z',
    updatedAt: '2026-10-01T00:00:00.000Z',
  },
  {
    id: 'uni_matrouh',
    name: 'جامعة مطروح',
    governorate: 'مطروح',
    city: 'مرسى مطروح',
    address: 'الكيلو 9 طريق مطروح - الإسكندرية',
    campus: 'الحرم الجامعي بالكيلو 9',
    active: true,
    isActive: true,
    createdAt: '2026-10-01T00:00:00.000Z',
    updatedAt: '2026-10-01T00:00:00.000Z',
  },
  {
    id: 'uni_aastmt_alamein',
    name: 'الأكاديمية العربية للعلوم والتكنولوجيا - فرع العلمين',
    governorate: 'مطروح',
    city: 'مدينة العلمين الجديدة',
    address: 'مدينة العلمين الجديدة - الساحل الشمالي',
    campus: 'فرع العلمين الجديدة',
    active: true,
    isActive: true,
    createdAt: '2026-10-01T00:00:00.000Z',
    updatedAt: '2026-10-01T00:00:00.000Z',
  },

  // === محافظة البحيرة (مجاورة للإسكندرية مباشرة) ===
  {
    id: 'uni_damanhour',
    name: 'جامعة دمنهور',
    governorate: 'البحيرة',
    city: 'دمنهور',
    address: 'مجمع الأبعادية التعليمي / شارع الجمهورية',
    campus: 'الأبعادية والمجمع النظري',
    active: true,
    isActive: true,
    createdAt: '2026-10-01T00:00:00.000Z',
    updatedAt: '2026-10-01T00:00:00.000Z',
  },
  {
    id: 'uni_damanhour_national',
    name: 'جامعة دمنهور الأهلية',
    governorate: 'البحيرة',
    city: 'دمنهور',
    address: 'مجمع الأبعادية - دمنهور - البحيرة',
    campus: 'مجمع الأبعادية الأهلي',
    active: true,
    isActive: true,
    createdAt: '2026-10-01T00:00:00.000Z',
    updatedAt: '2026-10-01T00:00:00.000Z',
  },
  {
    id: 'uni_rashid',
    name: 'جامعة رشيد الخاصة',
    governorate: 'البحيرة',
    city: 'رشيد الجديدة',
    address: 'مدينة رشيد الجديدة - الطريق الدولي الساحلي',
    campus: 'رشيد الجديدة',
    active: true,
    isActive: true,
    createdAt: '2026-10-01T00:00:00.000Z',
    updatedAt: '2026-10-01T00:00:00.000Z',
  },

  // === محافظة المنوفية / مدينة السادات (وجهة يومية لطلاب الإسكندرية) ===
  {
    id: 'uni_sadat_city',
    name: 'جامعة مدينة السادات',
    governorate: 'المنوفية',
    city: 'مدينة السادات',
    address: 'المنطقة السكنية السابعة / الحرم الجامعي الجديد - مدينة السادات',
    campus: 'مدينة السادات',
    active: true,
    isActive: true,
    createdAt: '2026-10-01T00:00:00.000Z',
    updatedAt: '2026-10-01T00:00:00.000Z',
  },
  {
    id: 'uni_sadat_national',
    name: 'جامعة السادات الأهلية',
    governorate: 'المنوفية',
    city: 'مدينة السادات',
    address: 'طريق مصر الإسكندرية الصحراوي - مدينة السادات',
    campus: 'مدينة السادات',
    active: true,
    isActive: true,
    createdAt: '2026-10-01T00:00:00.000Z',
    updatedAt: '2026-10-01T00:00:00.000Z',
  },
  {
    id: 'uni_reyada_sadat',
    name: 'جامعة الريادة للعلوم والتكنولوجيا (RST)',
    governorate: 'المنوفية',
    city: 'مدينة السادات',
    address: 'المحور المركزي - المنطقة الرابعة عشر - مدينة السادات',
    campus: 'مدينة السادات',
    active: true,
    isActive: true,
    createdAt: '2026-10-01T00:00:00.000Z',
    updatedAt: '2026-10-01T00:00:00.000Z',
  },
  {
    id: 'uni_menoufia',
    name: 'جامعة المنوفية',
    governorate: 'المنوفية',
    city: 'شبين الكوم',
    address: 'شارع جمال عبد الناصر - شبين الكوم',
    campus: 'شبين الكوم',
    active: true,
    isActive: true,
    createdAt: '2026-10-01T00:00:00.000Z',
    updatedAt: '2026-10-01T00:00:00.000Z',
  },
  {
    id: 'uni_menoufia_national',
    name: 'جامعة المنوفية الأهلية',
    governorate: 'المنوفية',
    city: 'طوخ طنبشا',
    address: 'طريق مصر الإسكندرية الزراعي - طوخ طنبشا - بركة السبع',
    campus: 'طوخ طنبشا',
    active: true,
    isActive: true,
    createdAt: '2026-10-01T00:00:00.000Z',
    updatedAt: '2026-10-01T00:00:00.000Z',
  },
  {
    id: 'uni_delta_tech',
    name: 'جامعة الدلتا التكنولوجية',
    governorate: 'المنوفية',
    city: 'قويسنا',
    address: 'المنطقة الصناعية الرابعة - قويسنا',
    campus: 'قويسنا',
    active: true,
    isActive: true,
    createdAt: '2026-10-01T00:00:00.000Z',
    updatedAt: '2026-10-01T00:00:00.000Z',
  },

  // === محافظة الغربية (طنطا) ===
  {
    id: 'uni_tanta',
    name: 'جامعة طنطا',
    governorate: 'الغربية',
    city: 'طنطا',
    address: 'شارع الجيش / مجمع سبرباي التعليمي',
    campus: 'مجمع الكليات الطبية وسبرباي',
    active: true,
    isActive: true,
    createdAt: '2026-10-01T00:00:00.000Z',
    updatedAt: '2026-10-01T00:00:00.000Z',
  },
  {
    id: 'uni_tanta_national',
    name: 'جامعة طنطا الأهلية',
    governorate: 'الغربية',
    city: 'طنطا',
    address: 'مجمع سبرباي - طنطا - الغربية',
    campus: 'مجمع سبرباي',
    active: true,
    isActive: true,
    createdAt: '2026-10-01T00:00:00.000Z',
    updatedAt: '2026-10-01T00:00:00.000Z',
  },
  {
    id: 'uni_samannoud_tech',
    name: 'جامعة سمنود التكنولوجية',
    governorate: 'الغربية',
    city: 'سمنود',
    address: 'طريق بهبيت الحجارة - سمنود - الغربية',
    campus: 'سمنود',
    active: true,
    isActive: true,
    createdAt: '2026-10-01T00:00:00.000Z',
    updatedAt: '2026-10-01T00:00:00.000Z',
  },

  // === محافظة كفر الشيخ ===
  {
    id: 'uni_kafr_elsheikh',
    name: 'جامعة كفر الشيخ',
    governorate: 'كفر الشيخ',
    city: 'كفر الشيخ',
    address: 'طريق سخا - الحرم الجامعي الجديد',
    campus: 'الحرم الجامعي الجديد',
    active: true,
    isActive: true,
    createdAt: '2026-10-01T00:00:00.000Z',
    updatedAt: '2026-10-01T00:00:00.000Z',
  },
  {
    id: 'uni_kafr_elsheikh_national',
    name: 'جامعة كفر الشيخ الأهلية',
    governorate: 'كفر الشيخ',
    city: 'كفر الشيخ',
    address: 'طريق بلطيم - كفر الشيخ',
    campus: 'الحرم الجامعي الأهلي',
    active: true,
    isActive: true,
    createdAt: '2026-10-01T00:00:00.000Z',
    updatedAt: '2026-10-01T00:00:00.000Z',
  },

  // === محافظة الدقهلية ودمياط ===
  {
    id: 'uni_mansoura',
    name: 'جامعة المنصورة',
    governorate: 'الدقهلية',
    city: 'المنصورة',
    address: 'شارع الجمهورية - الحرم الرئيسي',
    campus: 'شارع الجمهورية - الحرم الجامعي',
    active: true,
    isActive: true,
    createdAt: '2026-10-01T00:00:00.000Z',
    updatedAt: '2026-10-01T00:00:00.000Z',
  },
  {
    id: 'uni_mansoura_national',
    name: 'جامعة المنصورة الأهلية',
    governorate: 'الدقهلية',
    city: 'جمصة',
    address: 'الطريق الدولي الساحلي - جمصة',
    campus: 'حرم جمصة الذكي',
    active: true,
    isActive: true,
    createdAt: '2026-10-01T00:00:00.000Z',
    updatedAt: '2026-10-01T00:00:00.000Z',
  },
  {
    id: 'uni_delta_science',
    name: 'جامعة الدلتا للعلوم والتكنولوجيا',
    governorate: 'الدقهلية',
    city: 'جمصة',
    address: 'الطريق الدولي الساحلي - جمصة',
    campus: 'جمصة',
    active: true,
    isActive: true,
    createdAt: '2026-10-01T00:00:00.000Z',
    updatedAt: '2026-10-01T00:00:00.000Z',
  },
  {
    id: 'uni_damietta',
    name: 'جامعة دمياط',
    governorate: 'دمياط',
    city: 'دمياط الجديدة',
    address: 'الحي الرابع - دمياط الجديدة',
    campus: 'دمياط الجديدة',
    active: true,
    isActive: true,
    createdAt: '2026-10-01T00:00:00.000Z',
    updatedAt: '2026-10-01T00:00:00.000Z',
  },

  // === الجيزة والقاهرة الكبرى والقليوبية ===
  {
    id: 'uni_cairo',
    name: 'جامعة القاهرة',
    governorate: 'الجيزة',
    city: 'الجيزة / بين السرايات',
    address: 'شارع الجامعة - بين السرايات',
    campus: 'المقر الرئيسي - بين السرايات',
    active: true,
    isActive: true,
    createdAt: '2026-10-01T00:00:00.000Z',
    updatedAt: '2026-10-01T00:00:00.000Z',
  },
  {
    id: 'uni_ain_shams',
    name: 'جامعة عين شمس',
    governorate: 'القاهرة',
    city: 'العباسية',
    address: 'شارع الخليفة المأمون - العباسية',
    campus: 'العباسية - الحرم الرئيسي',
    active: true,
    isActive: true,
    createdAt: '2026-10-01T00:00:00.000Z',
    updatedAt: '2026-10-01T00:00:00.000Z',
  },
  {
    id: 'uni_helwan',
    name: 'جامعة حلوان',
    governorate: 'القاهرة',
    city: 'حلوان',
    address: 'محطة مترو عين حلوان',
    campus: 'عين حلوان',
    active: true,
    isActive: true,
    createdAt: '2026-10-01T00:00:00.000Z',
    updatedAt: '2026-10-01T00:00:00.000Z',
  },
  {
    id: 'uni_banha',
    name: 'جامعة بنها',
    governorate: 'القليوبية',
    city: 'بنها',
    address: 'شارع فريد ندا - بنها',
    campus: 'بنها ومشتهر',
    active: true,
    isActive: true,
    createdAt: '2026-10-01T00:00:00.000Z',
    updatedAt: '2026-10-01T00:00:00.000Z',
  },
  {
    id: 'uni_banha_national',
    name: 'جامعة بنها الأهلية',
    governorate: 'القليوبية',
    city: 'العبور',
    address: 'الحي الترفيهي - العبور',
    campus: 'العبور',
    active: true,
    isActive: true,
    createdAt: '2026-10-01T00:00:00.000Z',
    updatedAt: '2026-10-01T00:00:00.000Z',
  },
  {
    id: 'uni_october_6',
    name: 'جامعة 6 أكتوبر',
    governorate: 'الجيزة',
    city: '6 أكتوبر',
    address: 'المحور المركزي - الحي الأول - 6 أكتوبر',
    campus: '6 أكتوبر',
    active: true,
    isActive: true,
    createdAt: '2026-10-01T00:00:00.000Z',
    updatedAt: '2026-10-01T00:00:00.000Z',
  },
  {
    id: 'uni_must',
    name: 'جامعة مصر للعلوم والتكنولوجيا (MUST)',
    governorate: 'الجيزة',
    city: '6 أكتوبر',
    address: 'امتداد المحور المركزي - 6 أكتوبر',
    campus: '6 أكتوبر',
    active: true,
    isActive: true,
    createdAt: '2026-10-01T00:00:00.000Z',
    updatedAt: '2026-10-01T00:00:00.000Z',
  },
  {
    id: 'uni_msa',
    name: 'جامعة أكتوبر للعلوم الحديثة والآداب (MSA)',
    governorate: 'الجيزة',
    city: '6 أكتوبر',
    address: 'تقاطع طريق الواحات مع محور 26 يوليو',
    campus: '6 أكتوبر',
    active: true,
    isActive: true,
    createdAt: '2026-10-01T00:00:00.000Z',
    updatedAt: '2026-10-01T00:00:00.000Z',
  },
  {
    id: 'uni_nile',
    name: 'جامعة النيل الأهلية',
    governorate: 'الجيزة',
    city: 'الشيخ زايد',
    address: 'تقاطع محور 26 يوليو مع طريق وصلة دهشور - الشيخ زايد',
    campus: 'الشيخ زايد',
    active: true,
    isActive: true,
    createdAt: '2026-10-01T00:00:00.000Z',
    updatedAt: '2026-10-01T00:00:00.000Z',
  },
  {
    id: 'uni_zewail',
    name: 'مدينة زويل للعلوم والتكنولوجيا',
    governorate: 'الجيزة',
    city: 'حدائق أكتوبر',
    address: 'طريق أحمد زويل - حدائق أكتوبر',
    campus: 'حدائق أكتوبر',
    active: true,
    isActive: true,
    createdAt: '2026-10-01T00:00:00.000Z',
    updatedAt: '2026-10-01T00:00:00.000Z',
  },
  {
    id: 'uni_new_giza',
    name: 'جامعة الجيزة الجديدة (NGU)',
    governorate: 'الجيزة',
    city: '6 أكتوبر / طريق مصر إسكندرية الصحراوي',
    address: 'كيلو 35 طريق مصر الإسكندرية الصحراوي',
    campus: 'نيو جيزة',
    active: true,
    isActive: true,
    createdAt: '2026-10-01T00:00:00.000Z',
    updatedAt: '2026-10-01T00:00:00.000Z',
  },
  {
    id: 'uni_badr',
    name: 'جامعة بدر بالقاهرة (BUC)',
    governorate: 'القاهرة',
    city: 'مدينة بدر',
    address: 'طريق السويس - مدينة بدر',
    campus: 'مدينة بدر',
    active: true,
    isActive: true,
    createdAt: '2026-10-01T00:00:00.000Z',
    updatedAt: '2026-10-01T00:00:00.000Z',
  },
  {
    id: 'uni_bue',
    name: 'الجامعة البريطانية في مصر (BUE)',
    governorate: 'القاهرة',
    city: 'مدينة الشروق',
    address: 'طريق السويس - مدينة الشروق',
    campus: 'مدينة الشروق',
    active: true,
    isActive: true,
    createdAt: '2026-10-01T00:00:00.000Z',
    updatedAt: '2026-10-01T00:00:00.000Z',
  },
  {
    id: 'uni_guc',
    name: 'الجامعة الألمانية بالقاهرة (GUC)',
    governorate: 'القاهرة',
    city: 'القاهرة الجديدة',
    address: 'التجمع الخامس - القاهرة الجديدة',
    campus: 'التجمع الخامس',
    active: true,
    isActive: true,
    createdAt: '2026-10-01T00:00:00.000Z',
    updatedAt: '2026-10-01T00:00:00.000Z',
  },
  {
    id: 'uni_auc',
    name: 'الجامعة الأمريكية بالقاهرة (AUC)',
    governorate: 'القاهرة',
    city: 'القاهرة الجديدة',
    address: 'ميدان التحرير / التجمع الخامس',
    campus: 'التجمع الخامس',
    active: true,
    isActive: true,
    createdAt: '2026-10-01T00:00:00.000Z',
    updatedAt: '2026-10-01T00:00:00.000Z',
  },
  {
    id: 'uni_eui',
    name: 'جامعة مصر المعلوماتية (EUI)',
    governorate: 'القاهرة',
    city: 'العاصمة الإدارية الجديدة',
    address: 'مدينة المعرفة - العاصمة الإدارية الجديدة',
    campus: 'مدينة المعرفة',
    active: true,
    isActive: true,
    createdAt: '2026-10-01T00:00:00.000Z',
    updatedAt: '2026-10-01T00:00:00.000Z',
  },
  {
    id: 'uni_zagazig',
    name: 'جامعة الزقازيق',
    governorate: 'الشرقية',
    city: 'الزقازيق',
    address: 'الحرم الجامعي - الزقازيق',
    campus: 'الحرم الجامعي بالزقازيق',
    active: true,
    isActive: true,
    createdAt: '2026-10-01T00:00:00.000Z',
    updatedAt: '2026-10-01T00:00:00.000Z',
  },
];

export const SEED_VEHICLES: Vehicle[] = [
  {
    id: 'veh_01',
    vehicleNumber: 'س ق د 1842',
    plateNumber: 'س ق د 1842',
    type: 'BUS',
    model: 'حافلة سياحية مجهزة (50 راكباً) 2024',
    capacity: 50,
    status: 'ACTIVE',
    notes: 'حافلة 50 راكب مكيفة بالكامل مع نظام تتبع GPS ومقاعد مريحة',
    createdAt: '2026-10-01T00:00:00.000Z',
    updatedAt: '2026-10-01T00:00:00.000Z',
  },
  {
    id: 'veh_02',
    vehicleNumber: 'س م ر 3920',
    plateNumber: 'س م ر 3920',
    type: 'BUS',
    model: 'حافلة سياحية مجهزة (50 راكباً) 2024',
    capacity: 50,
    status: 'ACTIVE',
    notes: 'حافلة 50 راكب مكيفة بالكامل مع شاشات ومخارج شحن',
    createdAt: '2026-10-01T00:00:00.000Z',
    updatedAt: '2026-10-01T00:00:00.000Z',
  },
];
// Initial trips table starts clean (0 trips)
export const SEED_TRIPS: Trip[] = [];

